import { injectIntl } from 'react-intl';

import ReservationItem from './ReservationItem';

export default injectIntl(ReservationItem);
